const isStorybook = () => !!process?.env?.STORYBOOK_MODE;

export default isStorybook;
